import TileSmall from './TileSmall'

export * from './TileSmall'

export default TileSmall
